const userTabStorageKey = "userTabMetadata";

export const loadUserTabMetaData = () => {
  try {
    const serializedState = localStorage.getItem(userTabStorageKey);
    if (serializedState === null) {
      return {};
    }
    return JSON.parse(serializedState);
  } catch (err) {
    console.error(err);
    return {};
  }
};

export const storeUserTabMetadata = (_oldMetadata, newMetaData) => {
  // no need to redact the data
  try {
    if (newMetaData.hasOwnProperty("selectedColumns")) {
      const serializesState = JSON.stringify({ selectedColumns: newMetaData.selectedColumns });
      localStorage.setItem(userTabStorageKey, serializesState);
    }
  } catch (err) {
    console.error(err);
  }
};
